var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.params.data.transactionCode)?_c('div',{staticClass:"pointer accent_color text-dense",on:{"click":_vm.showModal}},[_vm._v(" TB-"+_vm._s(this.params.data.transactionCode)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }